import { useSuspenseQueries } from "@tanstack/react-query";
import {
  getNotificationPreferences,
  getNotifications,
} from "@/api/notifications";

export function useNotificationsQuery() {
  const [notificationsQuery, preferencesQuery] = useSuspenseQueries({
    queries: [
      {
        queryKey: ["notifications"],
        queryFn: async () => {
          return getNotifications();
        },
      },
      {
        queryKey: ["notification-preferences"],
        queryFn: async () => {
          return getNotificationPreferences();
        },
      },
    ],
  });

  return { notificationsQuery, preferencesQuery };
}
